import { localDateIso } from "./game";
import { bearing, interpolateGreatCircle } from "./geo";
import { findStubAirport } from "./stubAirports";
import { DailyPuzzle, LatLon } from "./types";

// Stubbed puzzle (London Heathrow to Athens) for building the UI before the
// API exists. The track is a great-circle line cut off 45% of the way along.
const origin = findStubAirport("LHR");
const destination = findStubAirport("ATH");

const CUTOFF = 0.45;
const TRACK_STEPS = 12;

const track: LatLon[] = Array.from({ length: TRACK_STEPS + 1 }, (_, i) =>
  interpolateGreatCircle(origin, destination, (i / TRACK_STEPS) * CUTOFF)
);
const current = track[track.length - 1];
const previous = track[track.length - 2];

export const stubPuzzle: DailyPuzzle = {
  // Dated for the player's own day, like the puzzles the API serves.
  date: localDateIso(),
  origin,
  destination,
  aircraftMaker: "Boeing",
  aircraftModel: "787-9",
  departureTimeLocal: "08:15 AM",
  airline: "British Airways",
  flightNumber: "BA 632",
  durationMinutes: 220,
  track,
  position: { ...current, direction: bearing(previous, current) },
  clues: [
    {
      type: "flight_time",
      shortFact: "~3½ hr flight",
      title: "About 3½ hours in the air",
      detail: "That is the whole journey, from take-off to landing.",
    },
    {
      type: "on_arrival",
      shortFact: "27°C · lands 15:20",
      title: "27°C and clear",
      detail: "It lands at 15:20 local time, two hours ahead of London.",
    },
    {
      type: "airline",
      shortFact: "British Airways",
      title: "British Airways",
      detail: "The airline operating this flight today.",
    },
    {
      type: "local_knowledge",
      shortFact: "Pays in euros",
      title: "Pays in euros",
      detail: "The currency you will need when you land.",
    },
  ],
};
